

































import { Vue, Component } from "vue-property-decorator";
import VueBase from "@/lib/vuebase";
import app from "@/lib/app";
import ajax from "@/lib/ajax";

@Component({})
export default class BindSchoolListView extends VueBase {
  schoolMFAS: Array<any> = [];

  onClickLeft() {
    window.history.go(-1);
  }
  onClickRight() {
    this.$router.push({ path: "/bindSchool" });
  }

  async getSchoolAuthList() {
    var openId = app.getOpenId();
    if(openId==null) {
     	this.$router.push('/auth')
    }
    await ajax.get("MFA/GetMFABindList?openId=" + openId).then((rep) => {
      this.schoolMFAS.push(...rep.data.result);
    });
  }
  getMFA(id: any) {
    this.$router.push({ path: "/mfaCodePage?id="+id});
  }
  async mounted() {
    await this.getSchoolAuthList();
  }
}
